import { render, staticRenderFns } from "./JinNangDetail.vue?vue&type=template&id=a793560e&scoped=true&"
import script from "./JinNangDetail.vue?vue&type=script&lang=js&"
export * from "./JinNangDetail.vue?vue&type=script&lang=js&"
import style0 from "./JinNangDetail.vue?vue&type=style&index=0&id=a793560e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a793560e",
  null
  
)

export default component.exports